import React, { FunctionComponent } from 'react';
import { SwitchComponentProps } from './SwitchComponent.types';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

export const SwitchComponent: FunctionComponent<
  SwitchComponentProps
> = props => {
  const {
    className,
    checked,
    color = 'primary',
    disabled = false,
    id,
    label,
    name,
    onChange,
    required = false,
    size = 'medium',
    value,
  } = props;
  if (label) {
    return (
      <FormControlLabel
        control={
          <Switch
            className={className}
            checked={checked}
            color={color}
            disabled={disabled}
            id={id}
            name={name}
            onChange={onChange}
            required={required}
            size={size}
            value={value}
          />
        }
        labelPlacement={label.placement || 'end'}
        label={label.node}
      />
    );
  }
  return (
    <Switch
      className={className}
      checked={checked}
      color={color}
      disabled={disabled}
      id={id}
      name={name}
      onChange={onChange}
      required={required}
      size={size}
      value={value}
    />
  );
};
